import { apiRequest, toQueryString } from './apiRequest';

export const commitActivityAPI = {
  getActivity: async (params: any = {}) => {
    const qs = toQueryString(params);
    return await apiRequest<any>(`/api/commit-activity${qs}`, { method: 'GET' });
  },
};
